import React, { useState, useEffect } from "react";

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch("/api/instagram/feed")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data.posts || []);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "2rem 0", color: "#285979" }}>
        Loading Instagram...
      </div>
    );
  }

  if (error || posts.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "2rem 0", color: "#285979" }}>
        <a
          href="https://www.instagram.com/jatinmorjewels/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#285979",
            textDecoration: "underline",
            fontFamily: "Raleway",
            fontSize: "1rem",
          }}
        >
          Visit us on Instagram →
        </a>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        gap: "6px",
        padding: "0 0.5rem",
      }}
    >
      {posts.slice(0, 8).map((post) => (
        <a
          key={post.id}
          href={post.permalink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", overflow: "hidden", borderRadius: "4px" }}
        >
          <div
            style={{
              width: "100%",
              paddingBottom: "100%",
              position: "relative",
              backgroundColor: "#f0f0f0",
            }}
          >
            <img
              src={
                post.mediaType === "VIDEO"
                  ? post.thumbnailUrl
                  : post.mediaUrl
              }
              alt={post.caption ? post.caption.substring(0, 60) : "Instagram post"}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              loading="lazy"
            />
            {post.mediaType === "VIDEO" && (
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  color: "white",
                  fontSize: "1rem",
                  textShadow: "0 1px 3px rgba(0,0,0,0.6)",
                }}
              >
                <i className="fas fa-play"></i>
              </div>
            )}
          </div>
        </a>
      ))}
    </div>
  );
};

export default InstagramFeed;
